import * as React from 'react';
import { FinishLabel as FinishLabelComponent } from '../../components/FinishLabel';

interface IFinishLabelProps {
  label?: string | null;
}

export function FinishLabel({ label }: IFinishLabelProps) {
  if (!label) {
    return null;
  }

  return <FinishLabelComponent label={label} />;
}
